import React, { useContext, useEffect, useRef, useState } from 'react'
import { dispatchHandler } from '../../helper/apiHelperFunctions'
import { useDispatch, useSelector } from 'react-redux'
import { getPermissionKey } from '../../helper/permissions';
import Icons from '../../assets/icons';
import GenericCustomButton from '../../genericComponents/GenericCustomButton';
import GenericFormFooterComponent from '../../genericComponents/forms/GenericFormFooterComponent';
import OnboardingSidebar from './components/OnboardingSidebar';
import OnboardingFormSection from './components/OnboardingFormSection';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { deleteCookie, getCookie } from '../../helper/genericFunction';
import { ReloadContext, UserDetailsContext } from '../../App';
import '../../styles/stylesheets/home/VendorOnboarding.scss'
import GenericFormHeaderComponent from '../../genericComponents/forms/GenericFormHeaderComponent';
import { getMenuMode } from '../../helper/helperTableFunctions';
import { Building2 } from 'lucide-react';

function VendorOnboardingMain(props) {

    const {mainClassName='', renderHeaderSection=null} =  props;

    const dispatch = useDispatch();
    const childRef = useRef();
    const history = useHistory();
    const {clearUserContext} = useContext(UserDetailsContext)
    const { handleDocumentStatusChange } = useContext(ReloadContext);

    const authStore = useSelector((state) => state.authStore);

    // Sidebar State
    const [currentStep, setCurrentStep] = useState(history?.location?.state?.currentStep || {})
    const [menuData, setMenuData] = useState(history?.location?.state?.menuData || {});
    const [submenuArray, setSubmenuArray] = useState(history?.location?.state?.submenuArray || [])

    // state to store form data - form component states
    const [inputData, setInputData] = useState({})
    const [errorData, setErrorData] = useState({})
    const [formSettings, setFormSettings] = useState({});

    const [runGetAll, setRunGetAll] = useState(false)
    const [ownerDetailsArray, setOwnerDetailsArray] = useState(["ownerDetails"])
    const [percentageData, setPercentageData] = useState({});
    const [termsAlreadySaved, setTermsAlreadySaved] = useState(false);

    let keysData = {
        "company": ["companyName", "companyType", "yearEstablished", "companyAddress", "country", "state", "city", "pincode", "latitude", "longitude", "website", "businessDescription", "productionCapacity"],
        "ownerDetails": ["Name", "Phone Number", "Email", "Aadhar Number", "Aadhar Upload", "Designation"],
        "primaryContactDetails": ["primaryContactName", "primaryContactPhone", "primaryContactEmail", "primaryContactDesignation", "primaryContactAadhaarNumber", "primaryContactAadhaarUpload"],
        "businessRegistrationComplaince": ["businessRegistrationNumber", "panNumber", "panUpload", "gstNumber", "gstUpload", "vatNumber", "vatUpload", "exciseNumber", "exciseUpload", "msmeNumber", "msmeUpload", "certificateOfIncorporationUpload", "termsConditionForVendor"],
        "financialDetails": ["bankName", "accountNumber", "ifscCode", "micrCode", "cancelledChequeUpload", "paymentTerms"],
        "categorySpecificDetails": ["Product Categories", "Warranty & Maintenance Terms", "Storage & Handling Requirements", "Shipping & Delivery Capabilities", "Production / Supply Capacity", "Delivery Timeline & Restrictions", "Subcontracting Allowed?", "OEM / Private Label Support", "Services Offered", "Technology Stack Used", "Cloud Capabilities", "Integration Capabilities", "SLAs & Support Details", "Existing Clients & References", "Manufacturing Capacity (Units/Month)", "Machinery Details", "Raw Material Sourcing", "Factory Audits", "Electrical Safety Compliance", "Electrical Safety or Energy Compliance Certificates", "Type of Consumables", "Shelf Life", "Batch & Expiry Management", "Packaging Type", "Barcoding & Labeling Standards", "Product Recall Process in Place",
            "Type of Garments / Fabrics", "Fabric Weaving Type", "Fabric Sourcing Details", "Sample Development Capability", "Quality Control Measures", "Service Type", "Nature of Services Provided", "Team Size & Expertise", "Dispatch Mode", "Logistics Partner Details", "Service Areas (Geographical)", "Pricing Model", "Return/Reject Handling Policy", "Describe Your Business Category", "Stock Availability & Lead Time"
        ],
        "applicableAcrossAllIndustries": ["Certifications", "NDA Signed", "Tax Invoice Capability", "Business Registration Certificate", "Cybersecurity Compliance", "Cybersecurity Compliance File", "Data Privacy Policy Available", "Data Privacy Policy Available File", "Regulatory Compliance"],
        "industrySpecificCompliance": ["BEE Star Rating", "BEE Star Rating File", "Electrical Safety Compliance", "Environmental, Health & Safety", "Food Safety & Hygiene Certifications", "Factory Audits", "Sustainability Certifications", "Tax Invoice Capability", "Business Registration Certificate", "NDA Signed"],
        "documentUploadSection": ["Demo / Portfolio", "Demo / Portfolio File", "NDA Document", "Regulatory Compliance Certificates", "Sustainability Certificates", "SLAs & Support Details", "SLAs & Support Details File", "Return/Reject Handling Policy Document", "Portfolio or Client References", "Pricing Sheet or MOQ Document", "Software Licensing & Certifications",
            "Software Licensing & Certifications File", "Cybersecurity Audit Report", "Data Privacy Policy Document", "Environmental Policy Document", "Factory Registration Certificate", "Food Safety Certificates", "Machinery Details", "Sample Development Documentation", "EHS Compliance Policy", "Product Recall SOP", "Barcoding & Labeling Compliance", "Electrical Safety or Energy Compliance", "Digital Sign-off Agreement Upload"
        ],
        "environment": ["Has your company examined the impact of its products/services on the environment?", "What percentage of your raw materials come from sustainable sources & recycled?", "Do you have any risk assessment matrix for sustainability for your product & services?", "Do you report emissions using specific standards?", "Do you track and report greenhouse gas emissions?", "Do you use any disclaimer for safe use of your product or in disposal or recycle?", "Do you have any internal assessment for sustainability paramerter or as per SEDEX 4 pillar?", "What are the percentages of non-biodegradable, compostible, recyclable, and hazardous waste?", "What percentage of water comes from recycled or harvested sources?"],
        "social": ["Does your company actively support women's involvement in decision-making and activities?", "Are there employees with disabilities in your company?", "What proportion of materials come from smaller producers?", "Are there programs to inform and educate your employees?", "What percentage of employees have health insurance?", "What percentage of employees have accident insurance?", "What percentage of employees receive paternity benefits?", "What percentage of employees are eligible for maternity benefits?", "What percentage have access to company-provided daycare?", "What percentage receive retirement benefits?", "Has your company addressed and taken steps to prevent sexual harassment?", "Have assessments been done to prevent child labor?", "Are there measures against forced labor?", "Are wages compliant with legal and fair standards?", "Is there a committee for addressing human rights impacts caused by the business?",
            "Do you prefer suppliers from marginalized groups?", "Do you have mechanisms for consumer feedback?", "Have employees been trained in health and safety?", "Have employees been trained for skill development?", "What percentage of affected workers have been re-employed?", "Does the company engage in Corporate Social Responsibility (CSR) activities?", "Do you have internal mechanisms to address human rights-related grievances?", "Is there an individual or committee designated to address human rights impacts caused by the business?",
        ],
        "governance": ["Does your company take part in Business Responsibility initiatives?", "Has your company adopted national and international standards?", "What portion of your materials meet your internal standards?", "Does your company have anti-corruption policies?", "Have all statutory dues been paid to government authorities?", "Are there any pending legal disputes or conflicts with the regulatory authorities?", "Are there policies against workplace discrimination?", "Are there mechanisms in place to address human rights issues?", "Is your company affiliated with trade associations?", "Have there been any privacy or data breaches?", "What channels/platforms provide information on your products/services?", "Have there been any data breaches or privacy incidents?"],
        "esgCertifications": ["ESG Certificationsits products/services on the environment?", "Social Compliance Certificate", "Child Labor Policy in Place?", "Fire Safety Compliance", "Waste Disposal Method", "Uses Renewable Energy?", "Grievance Redressal System", "Gender Diversity in Workforce", "Carbon Emission Reporting", "CSR Activities (Last Year)", "ESG Audit Score"]
    };

    useEffect(()=> {
        if(authStore?.vendorOnboardingSubmitData?.isSuccess) {
            if(submenuArray?.length === currentStep.stepCount) {
                if(getMenuMode?.() == "new") {
                    history.push('/app');
                }
                else {
                    history.push('/home');
                }
                props?.setAppStackDocState("");
            }
            else {
                setCurrentStep({ stepCount: currentStep.stepCount + 1, key: submenuArray[currentStep.stepCount] })
                dispatchHandler(dispatch, 'vendorOnboardingProgressPercentageRequest', { customDomain: ["quality.supplymint.com", "localhost"].some(key => window.location.hostname.includes(key)) ? "http://localhost3000.supplymint.com" : window.location?.hostname, userId: props?.vendorData?.userId }, getPermissionKey("common", "commonfunctionality", "upload"))
            }
        }
    }, [authStore?.vendorOnboardingSubmitData?.isSuccess])

    const payloadMandateKeys = [
        "companyName",
        "companyType",
        "yearEstablished",
        "companyAddress",
        "addressLine2",
        "city",
        "state",
        "country",
        "pincode",
        "latitude",
        "longitude",
        "website",
        "businessDescription",
        "productionCapacity",
        "ownerDetails",
        "primaryContactName",
        "primaryContactPhone",
        "primaryContactEmail",
        "primaryContactAadhaarNumber",
        "primaryContactAadhaarUpload",
        "primaryContactDesignation",
        "businessRegistrationNumber",
        "panNumber",
        "panUpload",
        "gstNumber",
        "gstUpload",
        "vatNumber",
        "vatUpload",
        "exciseNumber",
        "exciseUpload",
        "msmeNumber",
        "msmeUpload",
        "certificateOfIncorporationUpload",
        "bankName",
        "accountNumber",
        "ifscCode",
        "micrCode",
        "cancelledChequeUpload",
        "paymentTerms",
        "categorySpecificDetails",
        "termNConditionsAccepted"
    ];

    useEffect(() => {
        if(runGetAll) setRunGetAll(false)
        dispatchHandler(dispatch, 'vendorOnboardingGetRequest', { userId: props?.vendorData?.userId }, getPermissionKey("common", "commonfunctionality", "upload"))
    }, [runGetAll]);

    useEffect(() => {
        dispatchHandler(dispatch, 'vendorOnboardingProgressPercentageRequest', { customDomain: ["quality.supplymint.com", "localhost"].some(key => window.location.hostname.includes(key)) ? "http://localhost3000.supplymint.com" : window.location?.hostname, userId: props?.vendorData?.userId }, getPermissionKey("common", "commonfunctionality", "upload"))
    }, []);

    console.log("this is the input data", inputData)

    useEffect(() => {
        if (authStore?.vendorOnboardingGetData?.isSuccess) {
            const serverData = authStore?.vendorOnboardingGetData?.data?.resource || {};
            const inputDataClone = convertToInputData(serverData);
            setInputData(inputDataClone);

            // Check if terms were already accepted from the server
            const savedTermsVal = serverData?.["termNConditionsAccepted"] ?? serverData?.["termsConditionForVendor"];
            if (savedTermsVal == 1 || savedTermsVal === true || savedTermsVal === "1") {
                setTermsAlreadySaved(true);
            }
        }

        if(authStore?.vendorOnboardingProgressPercentageData?.isSuccess) {
            setPercentageData(authStore?.vendorOnboardingProgressPercentageData?.data || {})
        }
    }, [authStore?.vendorOnboardingGetData?.isSuccess, authStore?.vendorOnboardingProgressPercentageData?.isSuccess]);

    const convertArrayToObject = (arr, key) => {
        if(Array.isArray(arr)) return arr?.reduce((acc, item) => {
            acc[item] = { [key]: item };
            return acc;
        }, {});
    }

    const expandFileData = (str = "") => {
        if (typeof str !== "string") return null;
        const [id, baseUrl, filePath, fileName, oldFileName] = str.split("|");

        const url = `${baseUrl}/${filePath}/${fileName}?response-content-disposition=attachment`;
        return [{
            id: Number(id),
            filePath,
            fileName,
            oldFileName,
            url,
        }];
    }

    // Function : To perform the conversion in theb provided form
    const convertToInputData = (data) => {
        let company = {}, ownerDetails = {}, primaryContactDetails = {}, businessRegistrationComplaince = {}, financialDetails = {},
            categorySpecificDetails = {}, applicableAcrossAllIndustries = {}, industrySpecificCompliance = {}, documentUploadSection = {},
            environment = {}, social = {}, governance = {}, esgCertifications = {};

        keysData?.["company"]?.map(key => {
            switch (key) {
                case "city": case "country": case "state": case "companyType": {
                    if(data?.[key]) {
                        company[key] = data[key] ? {
                            [key]: data[key],
                        } : null;
                    }
                    break;
                }
                default: {
                    if (data?.[key]) {
                        company[key] = data?.[key] || null;
                    }
                    break;
                }
            }
        });

        const parsedOwnerDetails =
            typeof data?.ownerDetails === "string"
            ? JSON.parse(data?.ownerDetails || "{}")
            : data?.ownerDetails || {};
        let ownerDetailsArrayUpdate = ["ownerDetails"];
        Object.entries(parsedOwnerDetails || {}).forEach(([key, value]) => {
            if(key.startsWith("ownerDetails")) {
                if(key !== "ownerDetails") {
                    ownerDetailsArrayUpdate.push(key);
                }
                ownerDetails = {
                    ...ownerDetails || {},
                    [key]: {}
                }
                keysData?.["ownerDetails"]?.map(innerKey => {
                    
                    if (innerKey === "Aadhar Upload" && value?.[innerKey]) {
                        ownerDetails[key][innerKey] = expandFileData(value?.[innerKey] || "");
                    }
                    else if(value?.[innerKey]) {
                        ownerDetails[key][innerKey] = value?.[innerKey] || null;
                    }
                });
            }
        });

        // console.log("fsdfsdfdsgdgdgeregdv", ownerDetails)

        setOwnerDetailsArray(ownerDetailsArrayUpdate); 

        keysData?.["primaryContactDetails"]?.map(key => {
            if(key === "primaryContactAadhaarUpload" && data?.[key]) {
                primaryContactDetails[key] = expandFileData(data?.[key] || "");
            }
            else if (data?.[key]) {
                primaryContactDetails[key] = data?.[key] || null;
            }
        });

        keysData?.["businessRegistrationComplaince"]?.map(key => {
            switch (key) {
                case "gstUpload": case "panUpload": case "msmeUpload": case "vatUpload": case "exciseUpload": case "certificateOfIncorporationUpload": case "Data Privacy Policy Available": {
                    if(data?.[key]) businessRegistrationComplaince[key] = expandFileData(data?.[key] || "");
                }
                    break;
                case "termsConditionForVendor": case "termNConditionsAccepted": {
                    let val = data?.["termNConditionsAccepted"] ?? data?.["termsConditionForVendor"] ?? data?.[key];
                    businessRegistrationComplaince[key] = (val == 1 || val === true || val === "1") ? 1 : 0;
                    break;
                }
                default: {
                    if(data[key]) {
                        businessRegistrationComplaince[key] = data?.[key] || null;
                    }
                }
                    break;
            }
        });

        keysData?.["financialDetails"]?.map(key => {
            if(key === "cancelledChequeUpload" && data[key]) {
                financialDetails[key] = expandFileData(data[key]);
            }
            else if(key === "paymentTerms" && data[key]) {
                financialDetails[key] = data[key] ? {
                    [key]: data[key],
                } : null;
            }
            else if (data?.[key]) {
                financialDetails[key] = data?.[key] || null;
            }
        });

        keysData?.["categorySpecificDetails"]?.map(key => {
            let parsedCategorySpecificDetails = JSON.parse(data?.categorySpecificDetails || "{}");
            console.log("categorySpecificDetails", parsedCategorySpecificDetails, convertArrayToObject(parsedCategorySpecificDetails?.["Factory Audits"] || [], key))
            if ((key === "Cloud Capabilities" || key === "Product Categories" || key === "Packaging Type" || key == "") && parsedCategorySpecificDetails?.[key]) {
                categorySpecificDetails[key] = convertArrayToObject(parsedCategorySpecificDetails?.[key] || [], key);
            }
            else if ((key === "Subcontracting Allowed?" || key === "OEM / Private Label Support" || key === "Sample Development Capability") && parsedCategorySpecificDetails?.[key]) {
                categorySpecificDetails[key] = parsedCategorySpecificDetails[key] ? {
                    [key]: parsedCategorySpecificDetails[key],
                } : null;
            }
            else if(key == "Factory Audits" && parsedCategorySpecificDetails?.[key]) {
                if (Array.isArray(parsedCategorySpecificDetails?.[key])) {
                    categorySpecificDetails[key] = convertArrayToObject(parsedCategorySpecificDetails?.[key] || [], key);
                    parsedCategorySpecificDetails?.[key]?.map((item) => {
                        if(parsedCategorySpecificDetails?.[`${key}${item}file`]) categorySpecificDetails[`${key}${item}file`] = expandFileData(parsedCategorySpecificDetails?.[`${key}${item}file`])
                    })
                } else {
                    categorySpecificDetails[key] = parsedCategorySpecificDetails?.[key] || null;
                }
            }
            else if(parsedCategorySpecificDetails?.[key]) {
                categorySpecificDetails[key] = parsedCategorySpecificDetails?.[key] || null;
            }
        });

        keysData?.["applicableAcrossAllIndustries"]?.map(key => {
            let parsedapplicableAcrossAllIndustries = JSON.parse(data?.businessCertificationsCompliance || "{}")?.applicableAcrossAllIndustries || {};
            if ((key === "Certifications" || key === "Regulatory Compliance") && parsedapplicableAcrossAllIndustries?.[key]) {
                applicableAcrossAllIndustries[key] = convertArrayToObject(parsedapplicableAcrossAllIndustries?.[key] || [], key);
                parsedapplicableAcrossAllIndustries?.[key]?.map((item) => {
                    if(parsedapplicableAcrossAllIndustries?.[`${key}${item}file`]) applicableAcrossAllIndustries[`${key}${item}file`] = expandFileData(parsedapplicableAcrossAllIndustries?.[`${key}${item}file`])
                })
            }
            else if ((key === "Cybersecurity Compliance" || key === "Cybersecurity Compliance File" || key === "Data Privacy Policy Available File" || key === "Data Privacy Policy Available") && parsedapplicableAcrossAllIndustries?.[key]) {
                applicableAcrossAllIndustries[key] = expandFileData(parsedapplicableAcrossAllIndustries?.[key]);
            }
            else if ((key === "NDA Signed" || key === "Tax Invoice Capability" || key === "Business Registration Certificate") && parsedapplicableAcrossAllIndustries[key]) {
                applicableAcrossAllIndustries[key] = parsedapplicableAcrossAllIndustries[key] ? {
                    [key]: parsedapplicableAcrossAllIndustries[key],
                } : null;
            }
            else if(parsedapplicableAcrossAllIndustries[key]) {
                applicableAcrossAllIndustries[key] = parsedapplicableAcrossAllIndustries?.[key] || null;
            }
        });

        keysData?.["industrySpecificCompliance"]?.map(key => {
            let parsedindustrySpecificCompliance = JSON.parse(data?.businessCertificationsCompliance || "{}")?.industrySpecificCompliance || {};
            if ((key === "Electrical Safety Compliance" || key === "Food Safety & Hygiene Certifications" || key === "Factory Audits" || key === "Sustainability Certifications") && parsedindustrySpecificCompliance?.[key]) {
                industrySpecificCompliance[key] = convertArrayToObject(parsedindustrySpecificCompliance?.[key] || [], key);
                parsedindustrySpecificCompliance?.[key]?.map((item) => {
                    if(parsedindustrySpecificCompliance?.[`${key}${item}file`]) industrySpecificCompliance[`${key}${item}file`] = expandFileData(parsedindustrySpecificCompliance?.[`${key}${item}file`])
                })
            }
            else if ((key === "BEE Star Rating File" || key === "Environmental, Health & Safety" || key === "Business Registration Certificate") && parsedindustrySpecificCompliance?.[key]) {
                industrySpecificCompliance[key] = expandFileData(parsedindustrySpecificCompliance?.[key]);
            }
            else if ((key === "BEE Star Rating" || key === "Tax Invoice Capability" || key === "NDA Signed") && parsedindustrySpecificCompliance[key]) {
                industrySpecificCompliance[key] = parsedindustrySpecificCompliance[key] ? {
                    [key]: parsedindustrySpecificCompliance[key],
                } : null;
            }
            else if(parsedindustrySpecificCompliance?.[key]) {
                industrySpecificCompliance[key] = parsedindustrySpecificCompliance?.[key] || null;
            }
        });
        const arr = ['Return/Reject Handling Policy Document', 'Portfolio or Client References', 'Pricing Sheet or MOQ Document','Environmental Policy Document', 'Factory Registration Certificate', 'Sample Development Documentation', 'EHS Compliance Policy', 'Product Recall SOP', 'Barcoding & Labeling Compliance', 'Electrical Safety or Energy Compliance', 'Others', 'Demo / Portfolio File','SLAs & Support Details File','NDA Document', "Regulatory Compliance Certificates", "Sustainability Certificates", "EHS Compliance Policy", "Product Recall SOP"];

        keysData?.["documentUploadSection"]?.map(key => {
            let parseddocumentUploadSection = JSON.parse(data?.businessDocumentUpload || "{}");
            if ((arr.includes(key)) && parseddocumentUploadSection?.[key]) {
                documentUploadSection[key] = expandFileData(parseddocumentUploadSection?.[key]);
            }
            else if(parseddocumentUploadSection?.[key]) {
                documentUploadSection[key] = parseddocumentUploadSection?.[key] || null;
            }
        });

        keysData?.["environment"]?.map(key => {
            let parseEnvironment = JSON.parse(data?.esgParticulars || "{}")?.environment || {};
            if(parseEnvironment?.[key]) {
                environment[key] = parseEnvironment?.[key] || null;
            }
        });

        keysData?.["social"]?.map(key => {
            let parseSocial = JSON.parse(data?.esgParticulars || "{}")?.social || {};
            if(parseSocial?.[key]) {
                social[key] = parseSocial?.[key] || null;
            }
        });

        keysData?.["governance"]?.map(key => {
            let parseGovernance = JSON.parse(data?.esgParticulars || "{}")?.governance || {};
            if(parseGovernance?.[key]) {
                governance[key] = parseGovernance?.[key] || null;
            }
        });

        keysData?.["esgCertifications"]?.map(key => {
            let parseEsgCertifications = JSON.parse(data?.esgCertifications || "{}");
            if(parseEsgCertifications?.[key]) {
                esgCertifications[key] = parseEsgCertifications?.[key] || null;
            }
        });

        console.log('documentUploadSection', documentUploadSection)

        return {
            "company": company || {},
            "primaryContactDetails": primaryContactDetails || {},
            "businessRegistrationComplaince": businessRegistrationComplaince || {},
            "financialDetails": financialDetails || {},
            "categorySpecificDetails": categorySpecificDetails || {},
            "applicableAcrossAllIndustries": applicableAcrossAllIndustries || {},
            "industrySpecificCompliance": industrySpecificCompliance || {},
            "documentUploadSection": documentUploadSection || {},
            "environment": environment || {},
            "social": social || {},
            "governance": governance || {},
            "esgCertifications": esgCertifications || {},
            "id": data?.id || "",
            ...ownerDetails || {}
        };
    }

    const handleChange = (type) => {
        switch (type) {
            case "handleSkip": {
                if(submenuArray?.length === currentStep.stepCount) {
                    if(props?.viewMode) {
                        props?.closeModal?.();
                    }
                    else {
                        // Push to /app (new menu) so AppStack resolves the user's first active page; /home for old menu
                        if(getMenuMode?.() == "new") {
                            history.push('/app');
                        }
                        else {
                            history.push('/home');
                        }
                        props?.setAppStackDocState("");
                    }
                }
                else {
                    setErrorData({});
                    setCurrentStep({ stepCount: currentStep.stepCount + 1, key: submenuArray[currentStep.stepCount] })
                }
                break;
            }
            case "handleNext": {
                if (childRef.current.errorFunction()) return;
                    const compactFileData = (file) => {
                        const urlObj = new URL(file?.url);
                        const fullPath = urlObj?.pathname;
                        const [baseUrl, ...pathParts] = fullPath.split("/").filter(Boolean);

                        const filePath = pathParts.slice(0, -1).join("/");
                        const fileName = pathParts[pathParts.length - 1];

                        return `${file.id}|${urlObj.origin}/${baseUrl}|${filePath}|${fileName}|${file.oldFileName}`;
                    }
                // if (submenuArray?.[currentStep.stepCount]) {
                    let payload = {};
                    Object.keys(inputData)?.map((key) => {
                        switch (key) {
                            case "id": {
                                payload["id"] = inputData?.["id"] || "";
                                break;
                            }
                            case "categorySpecificDetails": {
                                let categorySpecificDetails = {};
                                Object.keys(inputData?.[key] || {})?.map((innerKey) => {
                                    if (innerKey === "Cloud Capabilities" || innerKey === "Product Categories" || innerKey === "Packaging Type" || innerKey === "Factory Audits") {
                                        categorySpecificDetails[innerKey] = Object.keys(inputData?.[key]?.[innerKey] || {});
                                    }
                                    else if (innerKey.startsWith("Factory Audits") && innerKey.endsWith("file") && Array.isArray(inputData?.[key]?.[innerKey]) && inputData?.[key]?.[innerKey]?.[0]) {
                                        categorySpecificDetails[innerKey] = compactFileData(inputData?.[key]?.[innerKey]?.[0]);
                                    }
                                    else if (inputData?.[key]?.[innerKey]?.[innerKey]) {
                                        categorySpecificDetails[innerKey] = inputData?.[key]?.[innerKey][innerKey] || ""
                                    }
                                    else categorySpecificDetails[innerKey] = inputData?.[key]?.[innerKey] || ""
                                })
                                payload["categorySpecificDetails"] = JSON.stringify(categorySpecificDetails);
                                break;
                            }
                            case "applicableAcrossAllIndustries": case "industrySpecificCompliance": {
                                let businessCertificationsCompliance = {
                                    ...payload?.["businessCertificationsCompliance"] || {},
                                    [key]: {}
                                };
                                Object.keys(inputData?.[key] || {})?.map((innerKey) => {
                                    if (innerKey === "Certifications" || innerKey === "Regulatory Compliance" || innerKey === "Electrical Safety Compliance" || innerKey === "Food Safety & Hygiene Certifications" || innerKey === "Factory Audits" || innerKey === "Sustainability Certifications") {
                                        businessCertificationsCompliance[key][innerKey] = Object.keys(inputData?.[key]?.[innerKey] || {});
                                    }
                                    else if(Array.isArray(inputData?.[key]?.[innerKey]) && inputData?.[key]?.[innerKey]?.[0]) {
                                        businessCertificationsCompliance[key][innerKey] = compactFileData(inputData?.[key]?.[innerKey]?.[0]);
                                    }
                                    else if (inputData?.[key]?.[innerKey]?.[innerKey]) {
                                        businessCertificationsCompliance[key][innerKey] = inputData?.[key]?.[innerKey][innerKey] || ""
                                    }
                                    else businessCertificationsCompliance[key][innerKey] = inputData?.[key]?.[innerKey] || ""
                                })
                                payload["businessCertificationsCompliance"] = businessCertificationsCompliance;
                                break;
                            }
                            case "documentUploadSection": {
                                let businessDocumentUpload = {};
                                Object.keys(inputData?.[key] || {})?.map((innerKey) => {
                                    if(Array.isArray(inputData?.[key]?.[innerKey]) && inputData?.[key]?.[innerKey]?.[0]?.url) {
                                        businessDocumentUpload[innerKey] = compactFileData(inputData?.[key]?.[innerKey]?.[0]);
                                    } else if(Array.isArray(inputData?.[key]?.[innerKey])) {
                                        businessDocumentUpload[innerKey] = inputData?.[key]?.[innerKey];
                                    }
                                    else if (inputData?.[key]?.[innerKey]?.[innerKey]) {
                                        businessDocumentUpload[innerKey] = inputData?.[key]?.[innerKey][innerKey] || ""
                                    }
                                    else businessDocumentUpload[innerKey] = inputData?.[key]?.[innerKey] || ""
                                })
                                payload["businessDocumentUpload"] = JSON.stringify(businessDocumentUpload);
                                break;
                            }
                            case "environment": case "social": case "governance": {
                                let esgParticulars = {
                                    ...payload?.esgParticulars || {},
                                    [key]: {}
                                };
                                Object.keys(inputData?.[key] || {})?.map((innerKey) => {
                                    esgParticulars[key][innerKey] = inputData?.[key]?.[innerKey]
                                })
                                payload["esgParticulars"] = esgParticulars;
                                break;
                            }
                            case "esgCertifications": {
                                let esgCertifications = {};
                                Object.keys(inputData?.[key] || {})?.map((innerKey) => {
                                    esgCertifications[innerKey] = inputData?.[key]?.[innerKey]
                                })
                                payload["esgCertifications"] = JSON.stringify(esgCertifications);
                                break;
                            }
                            default: {
                                if(key.startsWith("ownerDetails")) {
                                    let ownerDetails = {
                                        ...payload?.["ownerDetails"] || {},
                                        [key]: {}
                                    };
                                    Object.entries(inputData?.[key] || {}).forEach(([innerKey, value]) => {
                                        if (Array.isArray(value)) {
                                            ownerDetails[key][innerKey] = compactFileData(value[0]);
                                        } else if (value?.[innerKey]) {
                                            ownerDetails[key][innerKey] = value[innerKey] || "";
                                        } else {
                                            ownerDetails[key][innerKey] = value || "";
                                        }
                                    });
                                    Object.keys(ownerDetails[key]).forEach((newKey) => {
                                        if (!ownerDetails[key][newKey]) {
                                            delete ownerDetails[key][newKey];
                                        }
                                    });
                                    if(Object.keys(ownerDetails[key] || {})?.length == 0) {
                                        delete ownerDetails[key]
                                    }
                                    payload["ownerDetails"] = ownerDetails
                                }
                                else {
                                    Object.keys(inputData?.[key] || {})?.map((innerKey) => {
                                        if (innerKey === "termsConditionForVendor" || innerKey === "termNConditionsAccepted") {
                                            payload["termNConditionsAccepted"] = inputData?.[key]?.[innerKey] ? 1 : 0;
                                        }
                                        else if(Array.isArray(inputData?.[key]?.[innerKey])) {
                                            // case "gstUpload": case "panUpload": case "msmeUpload": case "vatUpload": case "exciseUpload": case "certificateOfIncorporationUpload":
                                            payload[innerKey] = compactFileData(inputData?.[key]?.[innerKey]?.[0]);
                                        }
                                        else if (inputData?.[key]?.[innerKey]?.[innerKey]) {
                                            payload[innerKey] = inputData?.[key]?.[innerKey][innerKey] || ""
                                        }
                                        else payload[innerKey] = inputData?.[key]?.[innerKey] || ""
                                    })
                                }
                                break;
                            }
                        }
                    });
                    payload["ownerDetails"] = JSON.stringify(payload["ownerDetails"] || "{}");
                    payload["businessCertificationsCompliance"] = JSON.stringify(payload?.["businessCertificationsCompliance"] || "{}");
                    payload["esgParticulars"] = JSON.stringify(payload?.["esgParticulars"] || "{}");
                    payload["termNConditionsAccepted"] = (inputData?.["businessRegistrationComplaince"]?.["termsConditionForVendor"] || inputData?.["businessRegistrationComplaince"]?.["termNConditionsAccepted"]) ? 1 : 0;
                    delete payload["termsConditionForVendor"];
                    payloadMandateKeys.forEach((key) => {
                        if (!(key in payload)) {
                            payload[key] = "";
                        }
                    });
                    dispatchHandler(dispatch, 'vendorOnboardingSubmitRequest', payload, getPermissionKey("common", "commonfunctionality", "upload"))
                // }
                break;
            }
            case "handlePrevious": {
                setCurrentStep({ stepCount: currentStep.stepCount - 1, key: submenuArray[currentStep.stepCount - 2] })
                break;
            }
            case "logout": {
                dispatchHandler(dispatch, "userSessionCreateRequest", { token: sessionStorage.getItem('token') || "", flowType: "LOGGEDOUT" });
                deleteCookie('jwt')
                sessionStorage?.clear();
                clearUserContext?.();
                setTimeout(() => {
                    handleDocumentStatusChange();
                    props?.setAppStackDocState?.("");
                },1000);
                break;
            }
            default:
                break;
        }
    }

    const renderPageHeaderSection = () => {
        if(props?.viewMode) {
            return (
                <GenericFormHeaderComponent
                    headerClassName='sticky top-0 left-0 z-10 bg-white'
                    label={{
                        contentPrimary:    ()=>{
                            return(
                                <div className='flex items-center gap-6'>
                                    <h4>{props?.vendorData?.slName || ""}</h4>
                                    { menuData?.basic_details?.businessType && <div className='flex items-center gap-1'>
                                        <div><Building2 size={16} color='gray' /></div>
                                        <div className='text-gray-500 text-[11px] font-semibold capitalize'>{menuData?.basic_details?.businessType}</div>
                                    </div>}
                                </div>
                            )
                        }
                    }}
                    rowEndComponent={() => (
                        <div className='mr-5 flex items-center gap-3'>
                            <GenericCustomButton
                                onClick={ () => handleChange('handlePrevious')}
                                type="default"
                                label="Back"
                                disabled={currentStep?.stepCount === 1}
                                // leftIcon={<Icons.RightBigArrow className='iconBlack' />}
                                leftIcon= {<Icons.RightBigArrow height={19} className='iconBlack rotate-180' />}
                            />
                            <GenericCustomButton
                                type='primary'
                                label='Next'
                                onClick={() => handleChange('handleSkip')}
                                // rightIcon={<Icons.RightBigArrow />}
                                rightIcon= {<Icons.RightBigArrow height={19} />}
                                disabled={props?.viewMode && submenuArray?.length === currentStep.stepCount}
                            />
                        </div>
                    )}
                    closeModal={props?.closeModal}
                />
            )
        }
        return (
            // renderHeaderSection ? typeof renderHeaderSection === 'function' ? renderHeaderSection() : renderHeaderSection :
            <div className='vo-top pr-2'>
                <div className='flex items-center'>
                    <div className='vot-left relative'><Icons.SupplymintRIcon /></div>
                    {menuData?.basic_details?.businessType && <div className='flex items-center gap-1 ml-[60px]'>
                        <div><Building2 size={22} color='gray' /></div>
                        <div className='text-gray-500 text-[14px] font-semibold capitalize'>{menuData?.basic_details?.businessType}</div>
                    </div>}
                </div>
                <div className='vot-right'>
                    <GenericCustomButton
                        type='rejectOutline'
                        size='large'
                        leftIcon={<Icons.LogoutIcon />}
                        label='Logout'
                        onClick={() => handleChange('logout')}
                        className='mr-2.5'
                    />
                    <GenericCustomButton
                        type='outline'
                        size='large'
                        label='Skip, I will do it later'
                        onClick={() => handleChange('handleSkip')}
                    />
                    <GenericFormFooterComponent
                        buttons={[
                            currentStep?.stepCount > 1 && {
                                onClick: () => handleChange('handlePrevious'),
                                type: "default",
                                label: "Back",
                                size: 'large',
                                leftIcon: <Icons.RightBigArrow className='iconBlack' />
                            },
                            {
                                onClick: () => handleChange('handleNext'),
                                type: "primary",
                                label: "Save & Continue",
                                size: 'large',
                                rightIcon: <Icons.RightBigArrow />,
                                disabled: () => Object.values(errorData)?.some(item => Object.keys(item)?.length > 0) || !currentStep?.key
                            }
                        ]}
                    />
                </div>
            </div>
        )
    }

    const renderBottomSection = () => {
        return (
            <div className={`pageBody mx-auto p-[20px] max-w-[1070px] grid items-start gap-[20px]`} style={{ gridTemplateColumns: '310px auto' }}>
                {/* <button onClick={() => setRunGetAll(true)}>Run Get All</button> */}
                <OnboardingSidebar
                    menuData={menuData}
                    setMenuData={setMenuData}
                    submenuArray={submenuArray}
                    setSubmenuArray={setSubmenuArray}
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    percentageData={percentageData}
                    {...props}
                />

                <OnboardingFormSection
                    inputData={inputData}
                    setInputData={setInputData}
                    errorData={errorData}
                    setErrorData={setErrorData}
                    formSettings={formSettings}
                    setFormSettings={setFormSettings}
                    currentStep={currentStep}
                    ref={childRef}
                    ownerDetailsArray={ownerDetailsArray}
                    setOwnerDetailsArray={setOwnerDetailsArray}
                    viewMode={props?.viewMode}
                    keysData={keysData}
                    userBusinessType={menuData?.basic_details?.businessType}
                    bootConfig={{}}
                    termsAlreadySaved={termsAlreadySaved}
                />
            </div>
        )
    }

    return (
        <div className={`vendor-onboarding ${mainClassName}`}>
            {renderPageHeaderSection()}

            {renderBottomSection()}
        </div>
    )
}

export default VendorOnboardingMain